/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
 $(window).on('load', function () {
    $('.SizeSwatch__Radio.selected-variant').each(function() {
        let packsize = $(this).attr('value');
        let initial_packsize = $(this).attr('initial-pack-size');
        initial_packsize = initial_packsize * 1;
      	packsize = packsize *1;
        if (packsize > 1) {
          let currentVal = $(this).attr('product-initial-value');
          currentVal = currentVal/100;
          currentVal = currentVal / initial_packsize;

          let price = $(this).parents('form').siblings('.ProductMeta').find('.ProductMeta__Price').text();
          let currency = window.theme.moneyFormat.replace('{{amount}}', '');
          price = price.replace(currency, '');
          price = price * 1;

          let currentPackSize = packsize * currentVal;
          let discountPrice = currentPackSize - price;
          let roundOffDiscount = Math.round(discountPrice * 100) / 100;
          if (roundOffDiscount > 0) {
              $(this).parents('form').siblings('.ProductMeta').find('.ProductMeta__PriceList.Heading').append('<span class="discounted-price">(Save ' + currency + roundOffDiscount + ")</span>");
		  }
      }
    });
 });

  $(document).ready(function() {
    $(document).on('change', '.SizeSwatch__Radio', function() {
        let packsize = $(this).attr('value');
        let initial_packsize = $(this).attr('initial-pack-size');
      
        initial_packsize = initial_packsize * 1;
      	packsize = packsize *1;
        if (packsize > 1) {
          let currentVal = $(this).attr('product-initial-value');
          currentVal = currentVal/100;
          currentVal = currentVal / initial_packsize;

          let price = $(this).parents('form').siblings('.ProductMeta').find('.ProductMeta__Price').text();
          let currency = window.theme.moneyFormat.replace('{{amount}}', '');
          price = price.replace(currency, '');
          price = price * 1;

          let currentPackSize = packsize * currentVal;
          let discountPrice = currentPackSize - price;
          let roundOffDiscount = Math.round(discountPrice * 100) / 100;
          if (roundOffDiscount > 0) {
                $(this).parents('form').siblings('.ProductMeta').find('.ProductMeta__PriceList.Heading').append('<span class="discounted-price">(Save ' + currency + roundOffDiscount + ")</span>");
		   }
        }
	});
  });
